import type React from 'react';

import type { ApiProduct } from '../../../../../models/ecommerce/product/ApiProduct';
import type { LoopSearchProductResults } from '../../../../search/models/models';

import { ProductListing } from '../../../../common/components/ProductListing';

const SearchOverlayResultList = (props: {
    items: LoopSearchProductResults['items'];
    renderItem: (item: ApiProduct, index: number) => React.ReactNode;
}) => {
    return (
        props.items.length && (
            <ProductListing>
                {props.items.map((item, index) => (
                    <li key={item.identifier}>{props.renderItem(item, index)}</li>
                ))}
            </ProductListing>
        )
    );
};

export default SearchOverlayResultList;
